enum TipoBuscaManipulacao {
    Codigo = 1,
    FormaFarmaceutica = 2,
    Paciente = 3,
    Manipulacao = 4,
}

export default TipoBuscaManipulacao;
